/**
 * React Query hook for fetching presigned URLs for viewing PDFs
 */

import { useQuery } from '@tanstack/react-query'
import httpClient, { pluckData } from 'src/utilities/http-client'

/**
 * Get presigned URL for viewing a PDF
 */
async function getPresignedUrl(
  blockID: string,
  basePath: string,
): Promise<string> {
  let response = await httpClient.get(`/api/${basePath}/blocks/${blockID}/pdf`)
  return pluckData(response)
}

/**
 * Hook to fetch presigned URL for viewing a PDF block
 */
export function usePDFViewerUrl(blockID: string, basePath: string) {
  return useQuery({
    queryKey: ['pdfViewerUrl', basePath, blockID],
    queryFn: () => getPresignedUrl(blockID, basePath),
    enabled: !!blockID,
    staleTime: 5 * 60 * 1000, // 5 minutes (presigned URLs typically expire after 15-60 mins)
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
}
